import React, { forwardRef, useState } from 'react';
import { useBackendApi } from '../../../helpers/backendHelper';
import { useGlobalState } from '../../../state/GlobalStateProvider';
import { FlexboxColumn } from '../../action/Flexbox';
import ButtonApi from '../../ButtonApi';
import Logo from '../../Logo/Logo';
import TextEditor from '../TextEditor/TextEditor';

const PostComment = forwardRef(({ postId, handleClose, updateComment }, ref) => {
  const [{ user }] = useGlobalState();
  const backendHelper = useBackendApi();

  const [reviewContent, setReviewContent] = useState();

  async function handleSubmit() {
    const formData = new FormData();

    formData.append('content', reviewContent);
    formData.append('postId', postId);
    try {
      const response = await backendHelper.reviews.postComment(formData);

      alert.success('Comment posted');

      updateComment(state => {
        state.comments = [
          {
            commentid: response?.data?.id,
            content: reviewContent,
            user: user,
            postId: postId,
          },
        ];
      });
      handleClose();
    } catch (error) {}
  }
  return (
    <FlexboxColumn className='post_commet_wrapper'>
      <TextEditor handleContent={setReviewContent} disableAttachments={true} />
      <ButtonApi className='feed_wrapper_write_post_button' disabled={!reviewContent} onClick={handleSubmit}>
        <Logo src={user?.avatarUrl} width={'2.5rem'} height={'2.5rem'} borderRadius='50%' />
        Post as {user?.name}
      </ButtonApi>
    </FlexboxColumn>
  );
});

export default PostComment;
